import OrderTableLineItem from '@/molecules/order-table-line-item';

import { OrderTableLine } from './OrderTableLine';

export type TypeOrderTableLine = typeof OrderTableLine & {
  Item: typeof OrderTableLineItem;
};

(OrderTableLine as TypeOrderTableLine).Item = OrderTableLineItem;

OrderTableLineItem.displayName = 'OrderTable.Line.Item';

export type { TypeOrderTableLineProps } from './types';
export type { TypeOrderTableLineItemProps } from '@/molecules/order-table-line-item';

export default OrderTableLine as TypeOrderTableLine;
